import { Injectable, inject } from "@angular/core";
import { UrlTree } from "@angular/router";
import { Observable, from, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { RouteAccessService } from "@core/services/route-access.service";
import { UserAssignmentNavigationService } from "@core/services/user-assignment-navigation.service";

@Injectable({
  providedIn: "root",
})
export class SessionHomeRedirectService {
  private readonly authService: RouteAccessService = inject(RouteAccessService);
  private readonly userAssignmentNavigation: UserAssignmentNavigationService = inject(
    UserAssignmentNavigationService,
  );

  guestCanActivate$(): Observable<boolean | UrlTree> {
    return from(this.authService.isAuthenticated()).pipe(
      switchMap((isAuthenticated: boolean) =>
        isAuthenticated
          ? this.userAssignmentNavigation.resolveDefaultHomeUrlTree$()
          : of(true),
      ),
    );
  }

  defaultHomeRedirect$(): Observable<UrlTree> {
    return from(this.authService.isAuthenticated()).pipe(
      switchMap((isAuthenticated: boolean) =>
        isAuthenticated
          ? this.userAssignmentNavigation.resolveDefaultHomeUrlTree$()
          : of(this.userAssignmentNavigation.defaultHomeUrlTree()),
      ),
    );
  }
}
